import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CheckboxQuestion, DropdownQuestion, QuestionBase, QuestionGroup } from 'core/components/forms';
import { SftpConfigurationsService } from '../services/sftp-configurations.service';

@Injectable()
export class ClientSftpQuestionsService {
  questions: QuestionBase<any>[];
  sftpQuestionGroup: QuestionGroup;
  defaultColumns = [
    'user_email',
    'pid',
    'group_name',
    'points',
    'start_date',
    'end_date',
    'status',
    'last_connection',
    'gameProgress',
    'playTime'
  ];

  constructor(
    protected translateService: TranslateService,
    protected sftpConfigurationsService: SftpConfigurationsService
  ) {}

  async getQuestions(sftpConfig: any) {
    await this.createSftpQuestionGroup(sftpConfig);

    this.questions = [this.sftpQuestionGroup];
    return this.questions;
  }

  public async createSftpQuestionGroup(sftpConfig: any): Promise<QuestionGroup> {
    const columns = await this.sftpConfigurationsService.getReportColumns();
    const columnOptions = columns.map(({ dataField, label }) => ({ key: dataField, value: label }));

    this.sftpQuestionGroup = new QuestionGroup({
      title: 'clients.config.sso.label',
      isSection: true,
      childQuestions: [
        new CheckboxQuestion({
          key: 'enabled',
          label: 'clients.config.sso.activate',
          value: sftpConfig ? sftpConfig.enabled : false
        }),
        new DropdownQuestion({
          key: 'interval',
          label: this.translateService.instant('clients.config.sftp.frequency'),
          class: 'col-2-offset',
          placeholder: 'actions.select',
          options: [
            { key: '1', value: this.translateService.instant('clients.config.sftp.interval.oneDay') },
            { key: '2', value: this.translateService.instant('clients.config.sftp.interval.twoDay') },
            { key: '7', value: this.translateService.instant('clients.config.sftp.interval.oneWeek') }
          ],
          validators: { required: true },
          value: sftpConfig && sftpConfig.reports.interval ? `${sftpConfig.reports.interval}` : ''
        }),
        new DropdownQuestion({
          hidden: true, // disable choosing columns, always use all available columns
          key: 'columns',
          label: this.translateService.instant('clients.config.sftp.columns'),
          class: 'col-1',
          placeholder: 'actions.select',
          multiple: true,
          options: columnOptions,
          validators: { required: true },
          value: columnOptions.map((option) => option.key)
        })
      ]
    });
    return this.sftpQuestionGroup;
  }
}
